<style lang="scss" scoped>
.fe {
	position: relative;
	top: 3px;
}
table {
	margin-bottom: 60px;
	tr {
		th:first-child {
			padding-left: 40px !important;
		}
		th:last-child {
			padding-right: 40px !important;
		}
	}
}
.padding {
	padding: 20px 40px;
}

button {
	font-size: 14px;
}
.warning-text {
	color: #d7553d;
	font-weight: 600;
}
</style>

<template>
	<div>
		<app-header>
			<template slot="header">
				<div class="d-flex">
					<h1><i class="fe fe-mail" style="margin-right: 15px"></i> Invite parents/caregivers</h1>
					<div class="ml-auto custom-width">
						<!-- <el-button @click="$router.push({name:`communication.log`})">View communication log</el-button> -->
						<el-button type="primary" @click="refetchGuardians">Refetch Guardians</el-button>
						<el-dropdown @command="toggle" style="margin-left: 10px; margin-right: 10px;">
							<el-button type="plain">
								Toggle selected
								<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu @command="toggle" slot="dropdown">
								<el-dropdown-item command="select-all">Select all</el-dropdown-item>
								<el-dropdown-item command="unselect-all">Unselect all</el-dropdown-item>
								<el-dropdown-item command="select-previous">Select previously sent</el-dropdown-item>
								<el-dropdown-item command="select-no-previous">Select not previously sent</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<el-dropdown @command="action" :disabled="!sendTo.length && !deleteInviteInputs.length">
							<el-button type="primary">
								Action selected
								<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu @command="action" slot="dropdown">
								<el-dropdown-item command="insert" :disabled="!sendTo.length">Send guardian invitation</el-dropdown-item>
								<el-dropdown-item command="delete" :disabled="!deleteInviteInputs.length" class="warning-text">Delete guardian invitation</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</template>
		</app-header>
		<div class="container">
			<div class="main-panel directory">
				<div class="padding">
					<el-input placeholder="Search students" v-model="term" prefix-icon="el-icon-search"></el-input>
				</div>
				<empty v-if="!$apollo.loading && guardianRows && !guardianRows.length" message="You have no users ready to send guardian invitations for."></empty>
				<table v-if="$apollo.loading || guardianRows && guardianRows.length" class="table" v-loading="$apollo.loading || loading">
					<thead>
						<tr>
							<th>Students details</th>
							<th>Parent details</th>
							<th>Parent email</th>
							<th style="text-align: center">
								Swap
								<br />parent
							</th>
							<th style="text-align: center">
								Sent
								<br />previously
							</th>
							<th>&nbsp;</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="!guardiansLoading">
							<GuardianRow v-for="row in guardianRows" :key="row.id" :user="row" :sendTo="sendTo"></GuardianRow>
						</template>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag";
import GuardianRow from "./GuardianRow";
import Fuse from "fuse.js";
import _, { cloneDeep, map, filter, find } from "lodash";
import Bugsnag from '@bugsnag/js';

export default {
	components: {
		GuardianRow,
	},

	data() {
		return {
			term: null,
			loading: false,
			refetchingGuardians: false,
		};
	},

	apollo: {
		Guardian: {
			query: gql`
				{
					Guardian {
						id
						forename
						surname
						email
						sp_id
						previousInvitations {
							invitedEmailAddress
							state
							invitationId
						}
						Parents {
							id
							contact_email
							contact_forename
							contact_id
							contact_surname
							contact_parental_responsibility
							contact_priority
						}
					}
				}
			`,
			fetchPolicy: "no-cache",
			error(error) {
				if (find(error.graphQLErrors, { message: "Unexpected error value: \"Permission error\"" })) {
					this.$message({
						message: "Edusync Google is missing permissions to access data at your school, please go to edu.wonde.com and activate all optional permissions relating to contacts to use this feature.",
						type: "error",
						showClose: true,
						duration: 0,
					});
					this.$router.push("/");
				}
			},
			update(data) {
				if (data.Guardian && data.Guardian.length > 0 && data.Guardian[0].id !== 'loading') {
					this.refetchingGuardians = false;
				}

				return map(cloneDeep(data.Guardian), (row) => {
					return {
						...row,
						selected: false,
						selectedParentRow: row.Parents && row.Parents[0],
					};
				});
			},
			pollInterval: 3000,
			skip() {
				return !this.guardiansLoading;
			},
		},
	},

	computed: {
		guardiansLoading() {
			if(this.refetchingGuardians) return true;
			return !(this.Guardian && this.Guardian.length && this.Guardian[0].id !== 'loading');
		},

		guardianRows() {
			if (this.term) {
				const options = {
					keys: ["forename", "surname", "email"],
				};

				const fuse = new Fuse(this.Guardian, options);

				return fuse.search(this.term);
			} else {
				return this.Guardian;
			}
		},
		sendTo() {
			return map(filter(this.guardianRows, guardian => {
				return guardian.selected && this.validEmail(guardian.selectedParentRow.contact_email)
			}), (row) => {
				return {
					personId: row.id,
					providerId: row.sp_id,
					contactId: row.selectedParentRow.contact_id,
					guardianEmail: row.selectedParentRow.contact_email
				};
			});
		},
		nonUniqueEmails() {
			return _(this.sendTo)
				.countBy("guardianEmail")
				.some(qty => qty > 1);
		},
		deleteInviteInputs() {
			return _(this.guardianRows)
				.filter((row) => {
					return row.selected === true;
				})
				.map((row) => {
					return {
						invitations: _(row.previousInvitations)
							.filter((invite) => {
								console.log(invite)
								return invite.state === "PENDING";
							})
							.map("invitationId")
							.value(),
						studentId: row.sp_id,
					}
				})
				.filter((invite) => {
					return !_.isEmpty(invite.invitations);
				})
				.map((invite) => {
					return _.map(invite.invitations, (id) => {
						return {
							providerId: invite.studentId,
							invitationId: id
						}
					})
				})
				.flatten()
				.value();
		}
	},
	methods: {
		toggle(command) {
			switch (command) {
				case "select-all":
					this.Guardian.forEach((row) => {
						row.selected = true;
					});
					break;
				case "select-no-previous":
					this.Guardian.forEach((row) => {
						row.selected = _.isEmpty(row.previousInvitations);
					});
					break;
				case "select-previous":
					this.Guardian.forEach((row) => {
						row.selected = !_.isEmpty(row.previousInvitations);
					});
					break;
				case "unselect-all":
					this.Guardian.forEach((row) => {
						row.selected = false;
					});
					break;
			}
		},
		action(command) {
			switch (command) {
				case "insert":
					this.sendByBatch("insert", this.sendTo);
					break;
				case "delete":
					this.confirmDelete();
					break;
			}
		},
		async sendByBatch(action, input) {
			if (input.length == 0) {
				this.$message.error("You have not selected any users");
				return;
			}

			this.loading = true;
			const perPage = 2;
			let curPage = 1;
			let promises = [];
			let chunk = _.chunk(input, perPage)[curPage - 1];
			
			while(chunk) {
				switch (action) {
					case "delete":
						promises.push(this.delete(chunk))
						break;
					case "insert":
					default:
						promises.push(this.send(chunk));
						break;
				}
				curPage++;
				chunk = _.chunk(input, perPage)[curPage - 1];
			}
			const responses = await Promise.all(promises);
			
			const countResponse = (code) => {
				return responses
					.map(obj => obj[code] || 0)
					.reduce((accumulator, current) => accumulator + current, 0);
			}
			
			const errorCount = countResponse(0);

			if (!errorCount) {
				this.$message.success(`${action === "insert" ? "Sending" : "Deleting"} guardian invitation successful`);
			} else {
				this.$message.warning(`${action === "insert" ? "Sending" : "Deleting"} guardian invitation complete. ${errorCount} failed, ${countResponse(1)} successful`);
			}
						
			await this.$apollo.queries.Guardian.refetch();

			this.loading = false;
		},
		async send(chunk) {
			try {
				const invitations = await this.$apollo.mutate({
					mutation: gql`
						mutation SendGuardianInvitation($invitations: [GuardianInvitationInput!]!) {
							SendGuardianInvitation(invitations: $invitations)
						}
					`,
					variables: {
						invitations: chunk,
					},
				});
				
				return _.countBy(invitations.data.SendGuardianInvitation);
			} catch (e) {
				Bugsnag.notify(e);
			}
		},
		async delete(chunk) {
			try {
				const invitations = await this.$apollo.mutate({
					mutation: gql`
						mutation DeleteGuardianInvitation($invitations: [GuardianInvitationInput!]!) {
							DeleteGuardianInvitation(invitations: $invitations)
						}
					`,
					variables: {
						invitations: chunk,
					},
				});
				
				return _.countBy(invitations.data.DeleteGuardianInvitation);
			} catch (e) {
				Bugsnag.notify(e);
			}
		},
		confirmDelete() {
			this.$confirm(
				`All selected PENDING guardian invitations will be withdrawn. Are you sure you want to proceed?`,
				"Warning",
				{
					confirmButtonText: "OK",
					cancelButtonText: "Cancel",
					type: "warning"
				}
			).then(async () => {
				await this.sendByBatch("delete", this.deleteInviteInputs);
			})
		},
		toggleAll() {
			this.Guardian.forEach((row) => {
				row.selected = !row.selected;
			});
		},
		validEmail: function (email) {
			var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		refetchGuardians: function() {
			this.$confirm(
				`Are you sure you want to trigger the job?`,
				"Warning",
				{
					confirmButtonText: "OK",
					cancelButtonText: "Cancel",
					type: "warning"
				}
			).then(async () => {
				try {
					await this.$apollo.mutate({
						mutation: gql`
							mutation CacheClear($item: CacheTypeEnum!){
								CacheClear(item: $item)
							}`,
						variables: {
							item: "guardians"
						}
					});
					this.refetchingGuardians = true;
					this.Guardian = [];
					await this.$apollo.queries.Guardian.refetch();
				} catch (e) {
					this.$message.error("Failed to re-fetch guardians");
				}
			})
		}
	},
};
</script>